export default __webpack_public_path__ + "static/media/placeholder_dummy2016-diy01-de.8a770917.png";